import { DefectGroupedByEenheid, groupDefectsByEenheidLmm } from '@/domain/defecten/defectEenheid';
import { Defect } from '@/types/Defecten';

/**
 * De LMM-API geeft per peilmoment alleen aantallen plus de bijbehorende defect-ids terug; de details van een
 * eenheid komen uit de plank. Deze join levert per eenheid één regel op, afgeleid uit exact dezelfde ids als
 * waarop de tabel zijn aantal eenheden baseert, zodat paneel en tabel elkaar niet kunnen tegenspreken.
 */
export const stellenUitVoorraad = (
  defectenVoorMaterieel: Defect[],
  ids: number[] | undefined,
): DefectGroupedByEenheid[] => {
  if (!ids?.length) return [];
  const idSet = new Set(ids);
  return groupDefectsByEenheidLmm(defectenVoorMaterieel.filter((defect) => idSet.has(defect.id)));
};
